<template>
  <div class="account" :id="providerName.toLowerCase()">
    <div class="account-provider">
      <div class="account-icon">
        <slot name="icon"/>
      </div>
      <a-text as="label" class="h6 account-name">
        {{ providerName }}
      </a-text>
      <img v-if="connected" class="account-connected" :src="successIcon" alt="account connected">
    </div>
    <div>
      <slot/>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed, defineProps} from 'vue';

const props = defineProps<{
  provider: {
    type: String,
    required: true,
  },
  connected: {
    type: Boolean,
    default: false,
  },
}>();

const providerName = computed(() => {
  switch (props.provider) {
    case 'google_oauth2':
    case 'google_oauth2_edurooms':
      return 'Google';
    case 'microsoft_graph':
      return 'Microsoft';
    case 'apple':
      return 'Apple';
    case 'google_with_classrooms':
      return 'Google Classroom';
    default:
      return '';
  }
})
const successIcon = computed(() => {
  return new URL('../../assets/images/icons/Success.svg', import.meta.url).href
})
</script>

<style lang="scss" scoped>
@import 'app/assets/stylesheets/resources/mixins/_media-queries.scss';
@import 'app/assets/stylesheets/resources/mixins/_fonts.scss';

.account {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 24px;
  border: 1px solid var(--grey-40);
  border-radius: 6px;
  @include screen('sm') {
    border: none;
    padding: 0;
  }

  &-provider {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &-logo {
    margin-right: 8px;
  }

  &-connected {
    margin-left: auto;
  }

  &-icon {
    display: flex;
    align-items: center;
  }

  /**
  * Rails's 'button_to' helper generates a form with a button inside it.
  * But we create our own inside it, so we want the helper's buttons to be styleless.
  */
  :deep() .account-icon img {
    width: 32px;
    height: 32px;
  }

  :deep() form.button_to > button {
    border-radius: 3px;
    cursor: pointer;
    display: inline-flex;
    padding: 2px;
    font-family: 'Neue Haas Grotesk Disp', 'Inter', 'Helvetica Neue', Arial, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #662e80;
    background-color: transparent;
    border: 1px solid transparent;

    .icon-tab {
      display: none;
      margin-right: 5px;
    }

    & > div span {
      display: block;
      text-transform: lowercase;

      &::first-letter {
        text-transform: capitalize;
      }
    }

    &:hover, &:focus-visible {
      background-color: #f5f2fb;
    }
  }
}
</style>
